import { useTranslation } from '../../context/translationContext';
import Button from '../button/Button';
import { DateField } from '../form/input/DateField';
import Select from '../select/Select';
import { FulltextSearch } from './FulltextSearch';
import { FilterItemType, FilterOption } from './TableFilter.types';
import useSessionStorage from '../../hooks/useSessionStorage';
import { sessionStorageKeys } from '../../utils/keys/sessionStorageKeys';

interface Props {
  filterId?: string;
  defaultFilterValues?: any;
  filter: any;
  setFilter: (filter: object) => void;
  filterOptions: FilterOption[];
}

/**
 * Component for filtering table records
 * Select | Date
 */
export const TableFilter = ({
  filterId,
  defaultFilterValues,
  filter,
  setFilter,
  filterOptions,
}: Props) => {
  const { t } = useTranslation();
  const [query, setQuery] = useSessionStorage<string>(
    sessionStorageKeys.OVERVIEW_FILTER + 'fulltext_' + filterId,
    '',
  );

  /**
   * Sets filters to default state (get all data)
   */
  const handleResetFilters = () => {
    if (!filter) return;
    if (defaultFilterValues) {
      // reset to default values
      setFilter(defaultFilterValues);
    } else {
      // reset to undefined
      let emptyFilter = {};
      Object.keys(filter).map((key: string) => {
        emptyFilter = { ...emptyFilter, [key]: undefined };
      });
      setFilter(emptyFilter);
    }
    setQuery('');
    // TODO - víc specifikovat a zobecnit ať se nemažou i info o otevřených tabech
    window.sessionStorage.clear();
    window.dispatchEvent(new Event('storage'));
  };

  return (
    <div className="flex">
      {filterOptions.length > 0 &&
        filterOptions.map((opt: FilterOption, index: number) => (
          <div className="mr-5" key={index}>
            <>
              {!opt.title && <br />}
              {opt.type === FilterItemType.SELECT && opt.data && opt.valueKey && (
                <Select
                  data={opt.data}
                  className={opt.className}
                  minWidth={180}
                  value={filter && opt.valueKey ? filter[opt.valueKey] : undefined}
                  onChange={(e) =>
                    opt.valueKey && setFilter({ ...filter, [opt.valueKey]: e.value })
                  }
                  valueKey={opt?.valueId}
                  title={opt.title ?? undefined}
                  labelKey="name"
                  key={index}
                />
              )}
              {opt.type === FilterItemType.DATE && (
                <DateField
                  handleChange={(e) => opt.valueKey && setFilter({ ...filter, [opt.valueKey]: e })}
                  placeholder={opt.title}
                  title={opt.title}
                  type={opt.dateType ?? 'Date'}
                  value={filter && opt.valueKey ? filter[opt.valueKey] : undefined}
                  key={index}
                />
              )}
              {opt.type === FilterItemType.FULLTEXT && opt.setData && (
                <div className="relative w-full mt-1">
                  <FulltextSearch
                    key={index}
                    data={opt.data}
                    setData={opt.setData}
                    includedFields={opt.includedFields}
                    query={query}
                    setQuery={setQuery}
                  />
                </div>
              )}
            </>
          </div>
        ))}
      <div className="mr-5 relative w-full mt-1">
        <br />
        <Button onClick={handleResetFilters} title={t('general.reset-filter')} />
      </div>
    </div>
  );
};
